import { Title } from '@angular/platform-browser';
var BreadcrumbsService = /** @class */ (function () {
    function BreadcrumbsService(_title) {
        this._title = _title;
        this.reset();
    }
    Object.defineProperty(BreadcrumbsService.prototype, "parts", {
        get: function () {
            return this._parts;
        },
        enumerable: true,
        configurable: true
    });
    BreadcrumbsService.prototype.start = function (part) {
        this.reset();
        return this.add(part);
    };
    BreadcrumbsService.prototype.add = function (part) {
        if (typeof part === 'string') {
            part = { name: part };
        }
        this._parts.push(part);
        this.setTitle(part.name);
        return this;
    };
    BreadcrumbsService.prototype.reset = function () {
        this._parts = [];
        this._title.setTitle('KKK');
        return this;
    };
    BreadcrumbsService.prototype.setTitle = function (title) {
        this._title.setTitle(title + " - KKK");
    };
    return BreadcrumbsService;
}());
export { BreadcrumbsService };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/breadcrumbs/breadcrumbs.service.ts.pre-build-optimizer.js